import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getTimeProfilesAPI } from './api';

export const GET_TIME_PROFILES = 'getTimeProfiles';

export function useGetTimeProfiles() {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery([
    GET_TIME_PROFILES, tenantId,
  ], () => getTimeProfilesAPI());

  return {
    timeProfiles: data?.timeProfiles || [],
    isLoading,
    isFetching,
    isError,
  };
}

